<!-- =========================================================================================
  File Name: TheCustomizer.vue
  Description: Template Customizer
  Component Name: TheCustomizer
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
    Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="app-customizer">

    <!-- Open Customizer Button -->
    <vs-button
      @click.stop="active=!active"
      color="dark"
      type="filled"
      class="customizer-btn"
      icon-pack="feather"
      icon="icon-box" 
      ref="appConfPanel" />

    <!-- Customizer Content -->
    <vs-sidebar
      click-not-close
      hidden-background
      position-right
      v-model="activateAppConfLocal"
      class="items-no-padding">
      <div class="h-full">
        
        <div class="customizer-header mt-6 flex items-center justify-between px-6">
          <div>
            <h4>APP CUSTOMIZER</h4>
            <small>Customize & Preview in Real Time</small>
          </div>
          <feather-icon icon="XIcon" @click.stop="closeAppConf()" class="cursor-pointer"></feather-icon>
        </div>

        <vs-divider class="mb-0" />

        <VuePerfectScrollbar class="scroll-area--customizer pt-4 pb-6" :settings="settings">

          <div class="px-6">
            <scope-filter show mini></scope-filter>
          </div>
        </VuePerfectScrollbar>
      </div>
    </vs-sidebar>
  </div>
</template>


<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'

import ScopeFilter from '@/app/shared/components/app-scope/ScopeFilter.vue';

export default {
  props: {
    show: { type: Boolean, required: false },
  },
  data() {
    return {
      active: false,
      settings: {
        maxScrollbarLength: 60,
        wheelSpeed: .60,
      },

    }
  },
  watch: {

  },
  computed: {
    activateAppConfLocal: {
      get() { 
        return this.show ? this.show : this.active; 
      },
      set(val) { 
        // this.$emit('activateAppConf', val) 
      }
    },
  },
  methods: {
    closeAppConf() {
      this.active = false;
      this.$emit('activateAppConf', this.active); 
    },
  },
  components: {
    VuePerfectScrollbar,
    ScopeFilter
  }
}

</script>


<style lang="scss">
#app-customizer {
  .vs-sidebar {
    position: fixed;
    z-index: 52000;
    width: 400px;
    max-width: 90vw;
    // @apply shadow-lg;
    box-shadow: 0 15px 30px 0 rgba(0,0,0,0.11), 0 5px 15px 0 rgba(0,0,0,0.08);
  }

  .customizer-btn {
    position: fixed;
    top: 44%;
    right: 0;
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
    z-index: 50000;

    .vs-icon {
      animation: spin 1.5s linear infinite;
    }
  }

  .scroll-area--customizer {
    height: calc(100% - 5rem);
  }
}
</style>

